module.exports = __webpack_public_path__ + "img/5.cedd7b93.png";